import { render, staticRenderFns } from "./Pencil.vue?vue&type=template&id=d3acb3e4&scoped=true"
import script from "./Pencil.vue?vue&type=script&lang=js"
export * from "./Pencil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3acb3e4",
  null
  
)

export default component.exports